module.exports = __webpack_public_path__ + "static/media/row-level-security-alert-2.98a1bc00.svg";